import { Organization } from '@klear/organization'
import type { OrganizationMeta } from '@klear/organization/meta'
import { Trader } from '@klear/trader/trader'

function organizationMetaFromTrader(trader: Trader): OrganizationMeta {
  if (trader.organizationMeta) {
    return { ...trader.organizationMeta }
  }
  return {
    size: trader.size ?? '',
    website: trader.website,
    dunsNumber: trader.dunsNumber,
    lei: trader.lei,
    ein: trader.ein,
    vatNumber: trader.vatNumber,
    parentOrganization: trader.parentOrganization
  }
}

export function traderToOrganization(trader: Trader): Organization {
  return new Organization({
    id: trader.organizationId,
    name: trader.name,
    description: trader.description,
    address: trader.address.with({}),
    meta: organizationMetaFromTrader(trader),
    hasKlearAccount: trader.hasKlearAccount ?? false,
    stripeAccountId: trader.stripeAccountId ?? undefined,
    completedKyc: trader.completedKyc
  })
}

export function traderApplyOrganization(trader: Trader, organization: Organization): void {
  trader.organizationId = organization.id
  trader.name = organization.name
  trader.description = organization.description
  trader.address = organization.address.with({})
  trader.size = (organization.size || undefined) as Trader['size']
  trader.website = organization.website || undefined
  trader.dunsNumber = organization.dunsNumber || undefined
  trader.lei = organization.lei || undefined
  trader.ein = organization.ein || undefined
  trader.vatNumber = organization.vatNumber || undefined
  trader.parentOrganization = organization.parentOrganization || undefined
  trader.completedKyc = organization.completedKyc
  trader.stripeAccountId = organization.stripeAccountId ?? null
  trader.hasKlearAccount = organization.hasKlearAccount
  trader.organizationMeta = organization.metaForDb()
}
